import { MembershipResponse } from '../models/general/Membership';
import { NtsUserMembership } from '../models/Response';

export const parseMemberships = (memberships: MembershipResponse[]): NtsUserMembership => (
  memberships.reduce((fin, { organizationId, roles }) => ({
    ...fin,
    [organizationId]: roles,
  }), {})
);
